/**
 * @name cookie存值
 * @param c_name 要保存字段的名称
 * @param value 要保存字段的值
 */
export default (c_name, value) => {
    document.cookie = `${c_name}=${escape(value)}`;
};
